<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="角色名称" name="keyword"></c-form-item>
					<c-form-item type="datetime" label="创建时间" start-name="dateMin" end-name="dateMax"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_system_role_add" color="sys" @click="navigateTo('/role_add')">新建角色</c-button>
			</m-operate>
			
			<c-table ref="table" code="system_role_list">
				<c-table-column
					label="角色名称"
					name="role_name"
				>
				</c-table-column>
				
				<c-table-column
					label="描述"
					name="remarks"
				>
				</c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button power="b_system_role_edit" @click="navigateTo(`/role_edit/${data.id}`)">编辑</c-table-button>
						<c-table-button power="b_system_role_del" @click="deleteHandle(data)">删除</c-table-button>
						<c-table-button power="b_system_role_field" @click="fieldPower(data)">字段权限</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="fieldPower" title="字段权限" width="600" @resolve="submitFieldPower">
			<div class="power">
				<div class="power-list">
					<div class="power-item">
						<c-checkbox :checked="powerAllCheck" @click="checkPower('all', $event)">全选</c-checkbox>
					</div>
					<div class="power-list">
						<div v-for="(item, i) in powerList" :key="i" class="power-item">
							<c-checkbox :checked="item.checked != 0" @click="checkPower(item, $event)">{{item.field_name}}</c-checkbox>
						</div>
					</div>
				</div>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_system_role',
		
		data() {
			return {
				powerList: []
			}
		},
		
		computed: {
			powerAllCheck() {
				return !!(this.powerList.length && !this.powerList.find(item => item.checked == 0));
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('roleList.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/system_role/list',
					data
				});
			},

			deleteHandle(data) {
				this.$confirm({
					text: '确定要删除【'+data.role_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/system_role/delete',
							data: {
								role_id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},

			fieldPower(data) {
				this.request({
					url: '/system_role/field_list',
					data: {
						role_id: data.id,
					},
					success: data => {
						this.powerList = data
					}
				});
				this._edit = data.id;
				this.powerList = [];
				this.$refs.fieldPower.open();
			},
			
			checkPower(item, state) {
				if (item == 'all') {
					this.powerList.forEach(item => {
						this.checkPower(item, state);
					});
				} else {
					item.checked = state ? 1 : 0;
				}
			},

			submitFieldPower() {
				this.request({
					url: '/system_role/field_edit',
					data: {
						role_id: this._edit,
						field_ids: Array.from(this.powerList.filter(item => item.checked != 0), item => {
							return {
								field_id: item.id
							}
						})
					},
					loading: true,
					success: data => {
						this.$message({
							text: '保存成功'
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.power {
		height: 300px;
		overflow: auto;
		
		&-list {
			clear: both;
			overflow: hidden;
			
			.power-list {
				margin-left: 40px;
				margin-bottom: 20px;
			}
		}
		
		&-item {
			float: left;
			margin-top: 15px;
			margin-left: 20px;
		}
	}
</style>